<template>
  <transition name="router-anim">
    <div class="kits">
      <!-- Total count display -->
      <div>
        <div class="prob-count custom" :style="outlierCountStyle" v-if="hasFilter || outlierLabel">
          <span v-if="outlierLabel" class="outlier-label">{{ outlierLabel }} : </span>{{ filtered_total }} of {{ sub_total }}
        </div>
        <div class="prob-count custom" v-else>
          Total: {{ sub_total }}
        </div>
      </div>
      <!-- Column headers -->
      <div class="kits-title">
        <div class="title id">KIT ID</div>
        <div class="title status">STATUS</div>
        <div class="title date">DATE</div>
        <div class="title first-name">NAME</div>
        <div class="title email">EMAIL</div>
        <div class="title result" @click="sortedByResult">
          REPORT RESULT
          <img src="../../images/dashboard/up.png" alt="#" v-if="sortedByStateResult === 'desc'" />
          <img class="down" src="../../images/dashboard/down.png" alt="#" v-else />
        </div>
        <div class="title shipdate" @click="sortedBy">
          <span>SHIP DATE</span>
          <img src="../../images/dashboard/up.png" alt="#" v-if="sortedByState === 'desc'" />
          <img class="down" src="../../images/dashboard/down.png" alt="#" v-else />
        </div>
      </div>
      <!-- Kit rows -->
      <div v-if="kits.length > 0">
        <div class="kits-item" v-for="item in kits" :key="item.id">
          <div class="kit-desc id" @click.stop="stopPropagation" @click="showModal(item.id, item.user_id, 'kit')">
            {{ convertKitId(item.kit_id) }}
          </div>
          <div class="kit-desc status" :style="statusOf(item) === 'on_hold' ? { color: 'rgb(232, 122, 1)' } : null">
            <span v-if="statusOf(item) === 'on_hold'">On Hold</span>
            <span v-if="statusOf(item) === 'archive'">Archived</span>
            <span v-if="statusOf(item) === 'analysis_completed'">Analysis Complete</span>
            <span v-if="statusOf(item) === 'analysis_failed'">Analysis Failed</span>
            <span v-if="statusOf(item) === 'partially_failed'">Analysis Partially Complete</span>
            <span v-if="statusOf(item) === 'lab_received'">Lab Received</span>
            <span v-if="statusOf(item) === 'accepted'">Accepted</span>
            <span v-if="statusOf(item) === 'dna_extraction'">DNA Extraction In Progress</span>
            <span v-if="statusOf(item) === 'sequencing'">Sequencing In Progress</span>
            <span v-if="statusOf(item) === 'lab_awaiting'">Submitted</span>
            <span v-if="statusOf(item) === 'shipped'">Sold</span>
            <span v-if="statusOf(item) === 'activated'">Activated</span>
            <span v-if="statusOf(item) === 'delivered'">Delivered</span>
            <span v-if="statusOf(item) === 'in_active'">Inactive</span>
            <!-- Status progress bar -->
            <div class="status-line" :style="statusOf(item) === 'on_hold' ? { backgroundColor: 'rgba(232, 122, 1, .4)' } : null">
              <div class="status-line-bg" :style="statusLineStyle(statusOf(item))"></div>
            </div>
          </div>
          <div class="kit-desc status-date">
            <span v-if="statusOf(item) === 'on_hold'">{{ date(item.onhold_at) }}</span>
            <span v-if="statusOf(item) === 'lab_received'">{{ date(item.received_at) }}</span>
            <span v-if="statusOf(item) === 'accepted'">{{ date(item.accepted_at) }}</span>
            <span v-if="statusOf(item) === 'dna_extraction'">{{ date(item.dna_extraction_at) }}</span>
            <span v-if="statusOf(item) === 'sequencing'">{{ date(item.sequencing_at) }}</span>
            <span v-if="statusOf(item) === 'lab_awaiting'">{{ date(item.awaiting_at) }}</span>
            <span v-if="statusOf(item) === 'shipped'">{{ date(item.shipped_at) }}</span>
            <span v-if="statusOf(item) === 'activated'">{{ date(item.activated_at) }}</span>
            <span v-if="statusOf(item) === 'delivered'">{{ date(item.delivered_at) }}</span>
            <span v-if="statusOf(item) === 'analysis_completed'">{{ date(item.completed_at) }}</span>
          </div>
          <div class="kit-desc first-name">
            <span>{{ item.collected_last_name }}, {{ item.collected_first_name }}</span>
          </div>
          <div class="kit-desc email">
            <span v-if="item.user">{{ item.user.email }}</span>
          </div>
          <div class="kit-desc result">
            <div v-if="statusOf(item) === 'analysis_completed'">
              <span class="status green" v-if="item.result === 0">Normal Fungal Ecology</span>
              <span class="status yellow" v-if="item.result === 1">Slightly Disrupted</span>
              <span class="status orange" v-if="item.result === 2">Moderately Disrupted</span>
              <span class="status red" v-if="item.result === 3">Significantly Disrupted</span>
            </div>
            <div v-else><span>N/A</span></div>
          </div>
          <div class="kit-desc date">{{ date(item.shipped_at) }}</div>
          <div class="kit-actions">
            <div class="kit-desc edit-kit-btn" @click="edit(item)" title="Edit">
              <img src="../../images/dashboard/icons8-edit-100.png" />
            </div>
            <div
              title="Login As Customer"
              class="login-kit-btn"
              v-if="role === 'superadmin' && item.user !== null && item.user !== undefined"
              @click="login(item.user)"
            >
              <img src="../../images/dashboard/login.svg" alt="#" />
            </div>
            <div title="Archive" class="archive-kit-btn"
              v-if="role === 'superadmin' && statusOf(item) !== 'archive' && statusOf(item) !== 'on_hold'"
              @click="archive(item)">
              <img src="../../images/dashboard/archive-black.png" alt="#" />
            </div>
            <div title="Unarchive" class="archive-kit-btn"
              v-if="role === 'superadmin' && statusOf(item) === 'archive'"
              @click="unarchive(item)">
              <img src="../../images/dashboard/unarchive.png" alt="#" />
            </div>
            <div title="Delete" class="remove-kit-btn" v-if="role === 'superadmin'" @click="remove(item)"></div>
          </div>
        </div>
      </div>
      <div v-else class="kits-item">
        <div class="kit-desc nodata">No Data Retrieved.</div>
      </div>
      <!-- Pagination -->
      <div class="pogination">
        <Paginate v-if="count_page > 1" :page-count="count_page" :value="current_page" :page-class="'pogination-item'"
          :click-handler="changePage" :prev-text="'<'" :next-text="'>'" :container-class="'pogination-wrap'" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Paginate from "vuejs-paginate";

const DASHES_REGEX = /[-\s]/g;

export default {
  name: "KitsV2",
  components: { Paginate },
  props: {
    activeOutlierType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      kits: [],
      count_page: 1,
      current_page: 1,
      sortedByState: "desc",
      sortedByStateResult: "desc",
      sortedByStateOrder: "desc",
      report: { total: 0 },
      sub_total: 0,
      filtered_total: 0
    };
  },
  methods: {
    ...mapActions([
      "testKitInfoV2",
      "getUserInfoV2",
      "sendSearchReqV2",
      "setSortedByV2",
      "setOrderByV2",
      "setPaginationPageV2"
    ]),
    changePage(item) {
      this.current_page = item;
      this.setPaginationPageV2(item).then(() => {
        this.sendSearchReqV2();
      });
    },
    parseKitId(kitId) {
      return kitId ? kitId.replace(DASHES_REGEX, "").substr(0, 11).toUpperCase() : undefined;
    },
    convertKitId(kitId) {
      const raw = this.parseKitId(kitId);
      return raw ? `${raw.substr(0, 2)}-${raw.substr(2, 2)}-${raw.substr(4, 3)}-${raw.substr(7, 4)}` : undefined;
    },
    statusLineStyle(status) {
      switch (status) {
        case 'in_active': return { width: '5%' };
        case 'shipped': return { width: '16.6%' };
        case 'delivered': return { width: '28.8%' };
        case 'activated': return { width: '49.8%' };
        case 'lab_awaiting': return { width: '66.4%' };
        // New lab order: Submitted → DNA Extraction → Sequencing → Lab Received → Completed.
        case 'accepted': return { width: '70%' };
        case 'dna_extraction': return { width: '78%' };
        case 'sequencing': return { width: '86%' };
        case 'lab_received': return { width: '94%' };
        case 'on_hold': return { width: '83%', backgroundColor: '#E87A01' };
        case 'analysis_failed': return { width: '100%', backgroundColor: 'red' };
        case 'partially_failed': return { width: '100%', backgroundColor: 'grey' };
        case 'analysis_completed': return { width: '100%' };
        default: return {};
      }
    },
    remove(item) {
      this.$emit("confurmDelKit", { show: true, id: item.id, kit_id: this.convertKitId(item.kit_id) });
    },
    archive(item) {
      this.$emit("confurmArvKit", { show: true, id: item.id, title: item.title, kit_id: item.kit_id });
    },
    unarchive(item) {
      this.$emit("confirmUnArvKit", { show: true, id: item.id, title: item.title, kit_id: item.kit_id });
    },
    async edit(item) {
      await this.testKitInfoV2(item.id);
      this.$emit("editKit", { show: true });
    },
    login(user) {
      this.$emit("confirmCusLogin", { show: true, user: user });
    },
    sortedBy() {
      this.sortedByState = this.sortedByState === "desc" ? "asc" : "desc";
      this.setOrderByV2("shipped_at");
      this.setSortedByV2(this.sortedByState).then(() => {
        this.sendSearchReqV2();
      });
    },
    sortedByResult() {
      this.sortedByStateResult = this.sortedByStateResult === "desc" ? "asc" : "desc";
      this.setOrderByV2("result");
      this.setSortedByV2(this.sortedByStateResult).then(() => {
        this.sendSearchReqV2();
      });
    },
    sortedByOrder() {
      this.sortedByStateOrder = this.sortedByStateOrder === "desc" ? "asc" : "desc";
      this.setOrderByV2("ordered_at");
      this.setSortedByV2(this.sortedByStateOrder).then(() => {
        this.sendSearchReqV2();
      });
    },
    showModal(kitId, userId, modal) {
      this.testKitInfoV2(kitId).then(() => {
        if (modal === "kit") {
          if (userId !== null) {
            this.getUserInfoV2(userId).then(() => {
              this.$emit("showModal", true);
            });
          } else {
            this.$emit("showModal", true);
          }
        } else if (modal === "hold") {
          this.$emit("showComment", {
            txt: this.$store.getters.getTestKitInfoV2.reason_on_hold,
            show: true,
            id: this.$store.getters.getTestKitInfoV2.id
          });
        }
      });
    },
    statusOf(item) {
      const s = item.status;
      const map = {0:'shipped',1:'activated',2:'lab_awaiting',3:'lab_received',4:'on_hold',5:'analysis_completed',6:'problem',7:'delivered',8:'archive',9:'returned',10:'analysis_failed',11:'partially_failed',12:'in_active',13:'dna_extraction',14:'sequencing',15:'report_ready',16:'accepted'};
      const key = typeof s === 'string' ? s : (map[s] || 'shipped');
      // The business status badge stays "Lab Received" throughout the post-upload
      // processing stages. DNA Extraction In Progress / Sequencing In Progress are
      // shown only on the kit TIMELINE (driven by dna_extraction_at /
      // sequencing_at), not as the list status — so the list label is simply the
      // business status. (Previously this derived the granular stage from
      // lab_stage, which made every Lab-Received kit read "Sequencing".)
      return key;
    },
    date(localDate) {
      if (localDate !== null && localDate !== undefined && localDate !== "") {
        var todayDate = localDate.slice(0, 10);
        let d = todayDate.split("-");
        if (d.length === 3 && d[0] && d[1] && d[2]) {
          return d[1] + '/' + d[2] + '/' + d[0];
        }
      }
      return "00/00/0000";
    },
    stopPropagation(event) {
      event.stopPropagation();
    }
  },
  computed: {
    ...mapGetters(["getAdminKitsV2", "paginationV2", "role", "adminReportV2", "getHasFilterV2"]),
    hasFilter() {
      return this.getHasFilterV2;
    },
    outlierLabel() {
      const labelMap = {
        ordered: 'Processing Outliers',
        shipped: 'Sold Outliers',
        delivered: 'Delivered Outliers',
        activated: 'Activated Outliers',
        awaiting: 'Awaiting Outliers',
        received: 'Received Outliers'
      };
      return labelMap[this.activeOutlierType] || null;
    },
    outlierCountStyle() {
      const colorMap = {
        ordered: '#43B02A',
        shipped: '#005EB8',
        delivered: '#98A4AE',
        activated: '#F1B434',
        awaiting: '#AC75BD',
        received: '#00BBDC'
      };
      const color = colorMap[this.activeOutlierType];
      return color ? { color } : null;
    }
  },
  watch: {
    getAdminKitsV2(obj) {
      this.kits = obj;
      this.sub_total = this.$store.getters.kitsSubTotalV2;
      this.filtered_total = this.$store.getters.completedKitCountV2;
    },
    paginationV2(num) {
      this.count_page = num;
      if (this.current_page > num) {
        this.current_page = 1;
      }
    },
    adminReportV2(obj) {
      if (!obj) return;
      this.report.total = Number(obj.total);
    }
  },
  mounted() {
    if (this.$store.getters.adminReportV2 != null) {
      this.report.total = Number(this.$store.getters.adminReportV2.total);
    }
    if (this.$store.getters.getAdminKitsV2) {
      this.kits = this.$store.getters.getAdminKitsV2;
      this.sub_total = this.$store.getters.kitsSubTotalV2;
      this.filtered_total = this.$store.getters.completedKitCountV2;
    }
    if (this.$store.getters.paginationV2 !== null) {
      this.count_page = this.$store.getters.paginationV2;
    }
  }
};
</script>

<style scoped lang="scss">
.kits {
  margin: 8px 0 0 0;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 10px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.title.id {
  min-width: 130px;
  width: 100%;
  max-width: 130px;
}
.kit-desc.id {
  min-width: 128px;
  width: 100%;
  max-width: 128px;
  cursor: pointer;
  transition: all 0.5s linear;
}
.kit-desc.id:hover {
  color: #005eb8;
  font-family: TTNormsRegular, sans-serif;
}
.title.status {
  min-width: 167px;
  width: 100%;
  max-width: 167px;
}
.kit-desc.status {
  min-width: 163px;
  width: 100%;
  max-width: 163px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.title.first-name {
  min-width: 140px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.first-name {
  min-width: 135px;
  width: 100%;
  max-width: 135px;
}
.title.email {
  min-width: 160px;
  width: 100%;
  max-width: 185px;
}
.kit-desc.email {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
  overflow: hidden;
}
.kit-desc.email span {
  width: 100%;
  max-width: 160px;
  overflow: hidden;
  display: inline-block;
}
.kit-desc.status span {
  width: 100%;
  max-width: 160px;
  overflow: hidden;
}
.kit-desc.first-name span {
  width: 100%;
  max-width: 140px;
  overflow: hidden;
  display: inline-block;
}
.title.date {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.date {
  min-width: 123px;
  width: 100%;
  max-width: 123px;
}
.title.orderdate {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-width: 110px;
  max-width: 110px;
  position: relative;
  cursor: pointer;
  gap: 10px;
}
.title.orderdate img {
  margin-top: -2px;
  max-width: 7px;
  height: 14px;
}
.title.orderdate .down {
  transform: rotate(180deg);
}
.kit-desc.orderdate {
  min-width: 110px;
  width: 100%;
  max-width: 110px;
}
.title.shipdate {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: relative;
  cursor: pointer;
  gap: 10px;
}
.title.shipdate img {
  margin-top: -2px;
  max-width: 7px;
  height: 14px;
}
.title.shipdate .down {
  transform: rotate(180deg);
}
.kit-desc.status-date {
  min-width: 140px;
  width: 100%;
  max-width: 140px;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 16px 30px;
  background-color: #fff;
  margin: 6px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kits-item:hover > .kit-desc.date {
  min-width: 70px;
  width: 100%;
  max-width: 70px;
}
.kits-item:hover .remove-kit-btn {
  display: block;
}
.kits-item:hover .archive-kit-btn {
  display: block;
}
.archive-kit-btn {
  display: none;
  cursor: pointer;
}
.archive-kit-btn img {
  width: 20px;
}
.kits-item:hover .erase-kit-btn {
  display: block;
  padding-right: 6px;
}
.erase-kit-btn {
  display: none;
  cursor: pointer;
}
.erase-kit-btn img {
  width: 20px;
}
.kits-item:hover .login-kit-btn {
  display: block;
  margin-right: -8px;
}
.login-kit-btn {
  display: none;
  cursor: pointer;
}
.login-kit-btn img {
  width: 25px;
}
.kit-desc {
  color: #58595b;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
}
.status-line {
  width: 100%;
  max-width: 140px;
  height: 3px;
  background-color: rgba(0, 70, 173, 0.3);
  margin: 5px 0 0 0;
  position: relative;
}
.status-line-bg {
  position: absolute;
  width: 50%;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  background-color: #005eb8;
}
.pogination {
  margin: 20px 0 0 0;
}
.onhold-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  max-width: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0 0 0 5px;
  cursor: pointer;
}
.onhold-btn-img {
  max-width: 100%;
}
.kit-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.onHoldStatus {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.title.result {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: relative;
  cursor: pointer;
  gap: 10px;
}
.kit-desc.result {
  min-width: 145px;
  width: 100%;
  max-width: 145px;
}
.title.result img {
  max-width: 7px;
  height: 14px;
  margin-top: -2px;
}
.title.result .down {
  transform: rotate(180deg);
}
.status.green { color: green; }
.status.red { color: red; }
.status.orange { color: orange; }
.status.purple { color: #ac75bd; }
.status.yellow { color: gold; }
.remove-kit-btn {
  display: none;
  position: absolute;
  width: 18px;
  height: 18px;
  border: 1px solid #58595b;
  border-radius: 5px;
  right: 5px;
  cursor: pointer;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 13px;
    background-color: #58595b;
    top: 50%;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%) rotate(-45deg);
  }
  &:hover {
    border-color: red;
    &:before,
    &:after {
      background-color: red;
    }
  }
}
@media print {
  .kits { display: none; }
}
.prob-count {
  text-align: right;
  color: #58595b;
  font-family: TTNormsLight, sans-serif;
  font-size: 13px;
  font-weight: bold;
}
.prob-count.custom {
  margin-bottom: 8px;
}
.outlier-label {
  font-family: TTNormsMedium, sans-serif;
  margin-left: 6px;
}
.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}
.kits-item:hover .edit-kit-btn {
  display: block;
}
.edit-kit-btn {
  display: none;
  cursor: pointer;
  margin-right: -10px;
}
.edit-kit-btn img {
  width: 20px;
}
</style>
